export const drawerWidth = 240
export const navItems = ["home", "about", "skills", "projects", "experience", "contact"]
export const githubProfile = "https://github.com/danielsimarro"
export const linkedInProfile = "https://www.linkedin.com/in/daniel-simarro-reigada"
export const emailID = "danisimarroreigada@gmail.com"
export const myAddress = "Marbella, Andalucía, Spain"
export const myName = "Daniel Simarro Reigada"
export const cvURL = "/CV_Daniel_Simarro.pdf"
